import { LogUpload } from "./core";

export default LogUpload;
